module.exports = __webpack_public_path__ + "static/media/forside_right_2.00965040.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/img/forside/forside_right_2.jpg
// module id = 1471
// module chunks = 0